import { AuthService } from '@/auth';
import { AuthRoutes } from '@/auth/mixins';

// @vue/component
export default {
  mixins: [
    AuthRoutes,
  ],
  computed: {
    confirmation_token() {
      return this.$route.query.confirmation_token;
    },
    user_uuid() {
      return this.$route.query.user_uuid;
    },
  },
  created() {
    if (!(this.user_uuid && this.confirmation_token)) {
      this.$router.replace(this.routes.redirect);
    } else {
      this.confirmEmail();
    }
  },
  methods: {
    async confirmEmail() {
      let redirectTo = this.routes.redirect;

      try {
        const credentials = {
          uuid: this.user_uuid,
          confirmation_token: this.confirmation_token,
        };
        await AuthService.verifyEmail(credentials);
      } catch (error) {
        // The request was made and the server responded with an error status code
        if (error.response && error.response.status === 404) {
          redirectTo = this.routes.signup;
        }
      } finally {
        this.$router.push(redirectTo);
      }
    },
  },
};
